<div class="cvdp-ind" (clickElsewhere)="closeDropdown()">

  <!-- Trigger -->
  <button type="button" class="cvdp-ind__trigger" [disabled]="indicatorDataLoadingStatus"
    [attr.aria-expanded]="indicatorSelectorVisible" aria-haspopup="listbox"
    [attr.aria-label]="'Indicator: ' + (indicatorSelected ? indicatorSelected.IndicatorShortName : 'none selected')"
    (click)="toggleDropdown()">
    <i class="cvdp-ind__icon" aria-hidden="true"
      [class.far]="!indicatorDataLoadingStatus" [class.fa-chart-bar]="!indicatorDataLoadingStatus"
      [class.fas]="indicatorDataLoadingStatus" [class.fa-spinner]="indicatorDataLoadingStatus"
      [class.fa-spin]="indicatorDataLoadingStatus"></i>
    <span class="cvdp-ind__value" [class.cvdp-ind__value--muted]="!indicatorSelected || indicatorDataLoadingStatus">
      <ng-container *ngIf="indicatorDataLoadingStatus">{{ indicatorDataLoadingStatus }}</ng-container>
      <ng-container *ngIf="!indicatorDataLoadingStatus && indicatorSelected">
        {{ indicatorSelected.IndicatorShortName }}
        <span class="cvdp-ind__code">{{ indicatorSelected.IndicatorCode }}</span>
      </ng-container>
      <ng-container *ngIf="!indicatorDataLoadingStatus && !indicatorSelected">{{ placeholder }}</ng-container>
    </span>
    <i class="fas fa-chevron-down cvdp-ind__caret" aria-hidden="true"></i>
  </button>

  <!-- Panel -->
  <div class="cvdp-ind__panel" [class.cvdp-ind__panel--end]="panelAlign === 'end'"
    *ngIf="indicatorSelectorVisible">

    <!-- Search: runs across every indicator for the period, not just the condition
         currently on show. -->
    <div class="cvdp-ind__search">
      <i class="fas fa-search cvdp-ind__search-icon" aria-hidden="true"></i>
      <label class="visually-hidden" [attr.for]="searchInputId">Search indicators</label>
      <input #searchInput [id]="searchInputId" type="text" class="cvdp-ind__search-input"
        placeholder="Search by name or code..." autocomplete="off"
        [value]="searchTerm"
        (input)="onSearchChange($any($event.target).value)"
        (keydown)="onSearchKeydown($event)" />
      <button type="button" class="cvdp-ind__search-clear" *ngIf="searching" (click)="clearSearch()"
        aria-label="Clear search">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <!-- Conditions. Hidden while searching, which deliberately ignores them. -->
    <div class="cvdp-ind__conditions" *ngIf="!searching">
      <button type="button" class="cvdp-ind__condition" *ngFor="let condition of conditions; trackBy: trackByValue"
        [class.cvdp-ind__condition--active]="condition.id == conditionSelected?.id"
        [attr.aria-pressed]="condition.id == conditionSelected?.id"
        (click)="filterByCondition(condition)"
        [ngbTooltip]="condition.name" placement="top-start">
        {{ condition.id }}
      </button>
    </div>

    <p class="cvdp-ind__result-count" *ngIf="searching" aria-live="polite">
      {{ indicators?.length || 0 }} {{ indicators?.length === 1 ? 'indicator' : 'indicators' }} across all conditions
    </p>

    <div class="cvdp-ind__scroll">

      <p class="cvdp-ind__empty" *ngIf="searching && indicators?.length === 0">
        No indicators match "{{ searchTerm }}". Try a shorter term, or part of the indicator code.
      </p>

      <div role="listbox" aria-label="Indicators">
        <button #indicatorButton type="button" role="option"
          *ngFor="let indicator of indicators; let i = index; trackBy: trackByIndicatorId"
          class="cvdp-ind__item"
          [class.cvdp-ind__item--selected]="indicatorSelected?.IndicatorID === indicator.IndicatorID"
          [class.cvdp-ind__item--active]="i === activeIndex"
          [attr.aria-selected]="indicatorSelected?.IndicatorID === indicator.IndicatorID"
          (click)="setIndicator(indicator.IndicatorID)">
          <i class="far cvdp-ind__item-mark" aria-hidden="true"
            [class.fa-dot-circle]="indicatorSelected?.IndicatorID === indicator.IndicatorID"
            [class.fa-circle]="indicatorSelected?.IndicatorID !== indicator.IndicatorID"></i>
          <span class="cvdp-ind__item-label">
            <span [innerHTML]="indicator.IndicatorShortName | highlight: searchPattern"></span>
            <span class="cvdp-ind__code" [innerHTML]="indicator.IndicatorCode | highlight: searchPattern"></span>
          </span>
        </button>
      </div>

      <!-- Notices. Tied to the condition on show, so they stand down while searching. -->
      <ng-container *ngIf="!searching">

        <!-- Missing HYP Indicators -->
        <div class="cvdp-ind__note" *ngIf="missingHypIndicators">
          Data for hypertension indicators <strong>CVD005HYP</strong>, <strong>CVDP002HYP</strong>, <strong>CVDP003HYP</strong>, <strong>CVDP004HYP</strong>, <strong>CVDP006HYP</strong> are not available for this time period, as only 9 months of blood pressure readings were taken in this extract. This issue has since been resolved and future data extracts will allow for regular updates to these indicators.
        </div>

        <!-- Missing 004CKD Indicator -->
        <div class="cvdp-ind__note" *ngIf="missing004CKDIndicator">
          The CVDPREVENT indicator <strong>CVDP004CKD:</strong><i> Percentage of patients aged 18 and over with GP recorded CKD categories G3a to G5
            (previously stage 3 to 5) with a record of a urine albumin:creatinine ratio (or protein:creatinine ratio) test in the preceding 12 months
          </i> has been re-introduced from the June 2023 update.
          However, any comparisons with the previous data periods will not be possible and hence, we have removed any previous data points. <a href="/methodology#004ckd" class="fw-bold">Read more...</a>
        </div>

        <div class="cvdp-ind__note" *ngIf="missingCVDP002ADMNIndicator">
          The CVDPREVENT indicator <i><strong>CVDP002ADMN:</strong> Data on hospital admissions for Frimley ICB has been removed for this period. Please see <a href="/methodology#002AF" class="fw-bold">methodology page</a> for details.</i>
        </div>

      </ng-container>

    </div>

  </div>
</div>
